import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { ScrollArea } from '~/primitives/scroll-area';
import { defaultUsersParams, usersParamsSchema } from './-SearchParams';
import { usersQuery } from '~/util/queries/public/users';
import { UsersFilters } from './-Filters';
import { UsersTable } from './-UsersTable';

export const Route = createFileRoute('/_authenticated/staff/users')({
    validateSearch: usersParamsSchema,
    search: {
        middlewares: [stripSearchParams(defaultUsersParams)],
    },
    loaderDeps: ({
        search: {
            placeholder_filter,
            name_filter,
            ban_level_filter,
            page,
            per_page,
        },
    }) => ({
        placeholder_filter,
        name_filter,
        ban_level_filter,
        page,
        per_page,
    }),
    loader: async ({ context: { queryClient }, deps: filters }) =>
        await queryClient.fetchQuery(usersQuery(filters)),
    component: Users,
    pendingMs: 3000,
});

function Users() {
    return (
        <main className="h-full flex justify-center">
            <div className="flex flex-col p-4 gap-4 size-full bg-background-dark rounded-2xl">
                <ScrollArea className="w-full lg:h-[calc(100vh-150px)]">
                    <h1 className="text-secondary-foreground">Users</h1>
                    <UsersFilters />
                    <UsersTable />
                </ScrollArea>
            </div>
        </main>
    );
}
